import { ActionIcon, Text } from "@mantine/core";
import {
  BaseNodeAdditionalDataType,
  BaseNodeComponentType,
  BaseNodeDataType,
  BaseNodePropsType,
  getNodeLabel,
  SpecializedNodeProps,
} from "../WorkflowUtils";
import BaseNode from "./BaseNode";
import { IconX } from "@tabler/icons-react";

type StartNodeAdditionalDataType = BaseNodeAdditionalDataType & {};

type StartNodeDataType = BaseNodeDataType<StartNodeAdditionalDataType>;

type Props = {} & BaseNodePropsType<StartNodeDataType>;

/**
 * Start node.
 *
 * Used to define the workflow's entry point.
 * Is unique, there can be only one StartNode, and it's required and must always be present.
 *
 * Displays a start icon.
 * Has only one east port.
 */
const DefaultNode: BaseNodeComponentType<Props> = (props) => {
  return (
    <BaseNode {...props}>
      {(nodeProps: SpecializedNodeProps<StartNodeDataType>) => {
        return (
          <div className={`node-content default-content`}>
            <Text fw={500} truncate="end" style={{ maxWidth: "200px" }}>
              {props.node?.data?.name}
            </Text>

            <Text size="xs" c="dimmed">
              {props.node?.data?.type
                ? getNodeLabel(props.node?.data?.type)
                : "N/A"}{" "}
              [ {props.node.id} ]
            </Text>

            {!props.isDisabled && (
              <ActionIcon
                size="sm"
                variant="transparent"
                color="red"
                style={{ position: "absolute", top: 0, right: 10 }}
                onClick={() => {
                  props.onDeleteNode(props.node);
                }}
              >
                <IconX />
              </ActionIcon>
            )}
          </div>
        );
      }}
    </BaseNode>
  );
};

export default DefaultNode;
